/*防伪查询处理请求
*/
function DoQuery(codedata)
{
    if(codedata=="")
    {
        $("#data").html('请输入防伪码!');
        return false;
    }
    $("#data").html('查询中,请稍后...');
    var clientUrl = "http://wsu.t3315.com/NewWebSrvCheckAddr/FWResult.aspx?jsoncallback=?";
    var QueryData= {QryType:"WEB", FwCode:codedata,MD5:"dXxHekV93UTWF25kpxHftQ==",IpAddr:"https://myhaylou.myshopify.com/"};
    $.ajax({
        type: "GET",
        url: clientUrl,
        dataType: "jsonp",
        data : QueryData,
        timeout:30000,
        beforeSend:function(XMLHttpRequest){
        },
        complete: function(XMLHttpRequest, textStatus){
        },
        success : OnSuccess,
        error : OnError
    });
}

function OnSuccess(json) {
    $("#data").html(json.FwResult);
    console.log( $("#data"),"测试")
}

function OnError(XMLHttpRequest, textStatus, errorThrown) {
    $("#data").html('网络错误，稍后请重新查询!');
}